<template>
  <section v-bind:id="menuItem.anchor" class="info p-90-0-60">
    <div class="container">
      <div class="row">

        <div class="col-12 mb-30 align-self-center">
          <h2 class="light dark mb-30">{{menuItem.name}} <span class="bold">{{menuItem.nameBold}}</span></h2>
        </div>

      </div>

      <div class="row formBackground">

       <div class="d-none d-lg-flex col-md-6">&nbsp;</div>
        <div class="col-md-6 col-lg-6 darkBackground pt-2 pb-2">
          <p></p>
        </div>          

        <div class="d-none d-lg-flex col-md-6">&nbsp;</div>
        <div class="col-md-6 col-lg-3 darkBackground pt-2">
          <input class="form-control" type="text" placeholder="Name*" id="name" v-model="form.name"/>
        </div>
        <div class="col-md-6 col-lg-3 darkBackground pt-2">
          <input class="form-control" type="text" placeholder="Rückrufnummer*" id="phone" v-model="form.phone"/>
        </div>

        <div class="d-none d-lg-flex col-md-6">&nbsp;</div>
        <div class="col-lg-6 darkBackground pt-2">
          <input class="form-control" type="email" placeholder="E-Mail*" id="email" v-model="form.email"/>
        </div>

        <div class="d-none d-lg-flex col-md-6">&nbsp;</div>
        <div class="col-lg-6 darkBackground pt-2">
          <textarea class="form-control" placeholder="Nachricht*" id="message" v-model="form.message" rows="5" />
        </div>

        <div class="d-none d-lg-flex col-md-6">&nbsp;</div>
        <div class="col-lg-6 darkBackground pt-2">
          <img class="img-fluid" v-if="captchaId" v-bind:src="formUrl + '/captcha.php?id=' + captchaId" />
          <button class="button button-2" v-on:click="newCaptcha()">Nicht lesbar?<i class="fas fa-refresh"></i></button>
        </div>

        <div class="d-none d-lg-flex col-md-6">&nbsp;</div>
        <div class="col-lg-6 darkBackground pt-2">
          <div class="form-group">
            <label for="value">Geben Sie hier den Text auf dem Bild ein.</label>
            <input class="form-control" type="text" placeholder="Text im Prüfbild" id="value" v-model="form.value"/>
          </div>

        </div>

        <div class="d-none d-lg-flex col-md-6">&nbsp;</div>
        <div class="col-md-6 darkBackground">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="accept" v-model="form.accept"/>
            <label class="form-check-label" for="accept">Ja, ich akzeptiere die <a href="/gdpr" style="color:white;font-weight: bold" target="_blank">Datenschutzbedingungen.</a></label>
          </div>
        </div>

        <div class="d-none d-lg-flex col-md-6">&nbsp;</div>
        <div class="col-md-2 darkBackground pl-2 pb-5">
          <button class="button button-2" v-bind:disabled="captchaId == null || !form.accept || busy" v-on:click="sendMail()">Senden <i class="fas fa-envelope"></i></button>
        </div>
        <div class="col-md-4 darkBackground">
          <div v-if="alert.show" class="alert" :class="alert.type">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" v-on:click="showAlert=false">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="alert-heading">{{alert.header}}</h4>
            <p>{{alert.message}}</p>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
  export default {
    components: {},
    data () {
      return {
        formUrl: 'https://www.praxismandt.de/contactform',
        captchaId: null,
        busy: false,
        form: {
          accept: false,
          id: null,
          value: null,
          name: null,
          email: null,
          message: null,
          phone: null
        },
        alert: {
          show: false,
          type: 'alert-info',
          header: null,
          message: null
        }
      }
    },
    props: ['menuItem'],
    computed: {
    },
    mounted () {
      this.newCaptcha()
    },
    methods: {
      newCaptcha () {
        this.$http.get(this.$data.formUrl + '/captchaid.php')
          .then((response) => {
            if (response.ok) {
              console.log(response.body.entries)
              this.$data.captchaId = response.body.captchaId
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      showAlert (header, message, type, timeout) {
        this.$data.alert.type = type
        this.$data.alert.message = message
        this.$data.alert.header = header
        this.$data.alert.show = true

        let that = this
        if (timeout) {
          setTimeout(function () {
            that.$data.alert.show = false
          }, timeout)
        }
      },
      sendMail () {
        this.$data.busy = true

        this.$data.form.id = this.$data.captchaId
        this.$http.post(this.$data.formUrl + '/formtarget.php', this.$data.form, {
          emulateJSON: true
        }).then((response) => {
          this.$data.busy = false
          if (response.ok) {
            console.log('okay')
            this.showAlert('Gesendet!', 'Vielen Dank für Ihre Anfrage.', 'alert-success', null)
          } else {
            console.log(response)
            this.showAlert('Fehler!', 'Die Anfrage konnte nicht gesendet werden.', 'alert-danger', 5000)
          }
        })
          .catch((error) => {
            this.$data.busy = false
            console.log(error)
            if (error.status === 403) {
              this.showAlert('Noch nicht ganz...', 'Der Text passt nicht zum Prüfbild.', 'alert-warning', 5000)
              console.log('Captcha not solved')
            } else if (error.status === 401) {
              this.showAlert('Noch nicht ganz...', 'Bitte füllen Sie alle Felder aus.', 'alert-warning', 5000)
            } else if (error.status === 400) {
              this.showAlert('Captcha abgelaufen', 'Das Formular wurde zu lange nicht benutzt.', 'alert-warning', 5000)
            } else {
              this.showAlert('Fehler', 'Die Anfrage konnte nicht gesendet werden.', 'alert-danger', 5000)
              console.log('error')
            }
          })
      }
    }
  }
</script>

<style scoped="scoped">
  .formBackground {
    background-clip: border-box;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .darkBackground {
    background-color:  rgba(63,63,63,0.8)!important;
    /*opacity: 98%!important;*/
  }

  .button:disabled{
    color: #aaaaaa;
    border-color: #aaaaaa;
  }

  @media (min-width: 992px) {
      .formBackground {
    background: url("/static/img/contact/contact.jpg") no-repeat;
    background-clip: border-box;
    background-repeat: no-repeat;
    background-size: contain;
  }

  }
</style>



// WEBPACK FOOTER //
// src/components/sections/Contact.vue